module.exports = __webpack_public_path__ + "img/sword_10.32916000.png";